import { render, staticRenderFns } from "./Recap.vue?vue&type=template&id=66015529"
import script from "./Recap.vue?vue&type=script&lang=ts"
export * from "./Recap.vue?vue&type=script&lang=ts"
import style0 from "./Recap.vue?vue&type=style&index=0&id=66015529&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports